import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserState } from '../../../core/models/i-user-state';
import { UserAction } from 'src/app/content-management/shared/enums/user-action';

@Component({
  selector: 'app-toastr-message',
  templateUrl: './toastr-message.component.html',
  styleUrls: ['./toastr-message.component.scss'],
})
export class ToastrMessageComponent {
  @Input() userList: UserState[] = [];
  @Input() title: string;
  @Input() userSaved?: string;
  @Output() close = new EventEmitter<void>();

  userActionMap = UserAction;

  onClose(): void {
    this.close.emit();
  }
}
